<template>
  <BaseDropdown
    @hide="checkModelUpdate"
  >
    <template #trigger="{ isActive }">
      <HeaderIconButton :is-active="isActive">
        <template #icon>
          <BrushCircleSvg />
        </template>
        <template #label>
          Dashboard settings
        </template>
      </HeaderIconButton>
    </template>

    <template #content>
      <div :class="$style.actionsWrapper">
        <BaseDropdownHeading>
          Edit this dashboard
        </BaseDropdownHeading>

        <BaseDropdownActionsList>
          <BaseDropdownActionField>
            <template #label>
              DASHBOARD NAME
            </template>

            <template #field>
              <BaseInput
                v-model="localModel.name"
                placeholder="Untitled"
              />
            </template>
          </BaseDropdownActionField>
          <BaseDropdownActionField>
            <template #label>
              DESCRIPTION
            </template>

            <template #field>
              <BaseInput
                v-model="localModel.description"
              />
            </template>
          </BaseDropdownActionField>
          <BaseDropdownActionField>
            <template #label>
              ICON
            </template>

            <template #field>
              <BaseMultiselect
                v-model="localModel.icon"
                :options="iconOptions"
                is-block
              />
            </template>
          </BaseDropdownActionField>
        </BaseDropdownActionsList>
      </div>
    </template>
  </BaseDropdown>
</template>

<script>
import { cloneDeep, isEqual } from 'lodash';
import BaseDropdown, {
  DropdownHeading as BaseDropdownHeading,
  DropdownActionsList as BaseDropdownActionsList, DropdownActionField as BaseDropdownActionField,
} from '@/components/base/Dropdown';
import BaseMultiselect from '@/components/base/Multiselect';
import BaseInput from '@/components/base/Input';
import HeaderIconButton from '@/components/HeaderIconButton';
import BrushCircleSvg from '@/assets/images/icons/brush-circle.svg?inline';
import { ICONS } from '@/dashboards';

export default {
  components: {
    BaseMultiselect,
    BaseDropdown,
    BaseDropdownHeading,
    BaseDropdownActionsList,
    BaseDropdownActionField,
    BaseInput,
    HeaderIconButton,
    BrushCircleSvg,
  },
  props: {
    modelValue: {
      type: null,
      default: null,
    },
  },
  emits: {
    'update:modelValue': null,
    remove: null,
  },
  data() {
    return {
      localModel: {},
      isRemoving: false,
      iconOptions: [
        {
          label: 'None',
          value: null,
        },
        ...ICONS.map((icon) => ({
          value: icon.id,
          label: icon.label,
        })),
      ],
    };
  },
  watch: {
    modelValue: {
      deep: true,
      handler(value) {
        this.localModel = cloneDeep(value);
      },
    },
  },
  created() {
    this.localModel = cloneDeep(this.modelValue);
  },
  methods: {
    checkModelUpdate() {
      if (this.isRemoving) return;

      if (!isEqual(this.modelValue, this.localModel)) {
        this.$emit('update:modelValue', cloneDeep(this.localModel));
      }
    },
    remove() {
      this.isRemoving = true;
      this.$emit('remove');
    },
  },
};
</script>

<style lang="scss" module>
.actionsWrapper {
  min-width: 300px;
}
</style>
